import { FunctionComponent, useMemo } from 'react'
import { FormControlLabelProps } from './types'
import useStyles from './styles'

export const FormControlLabel: FunctionComponent<FormControlLabelProps> = ({
  styles: overrides,
  control,
  label,
  rootProps = {},
}) => {
  const styles = useStyles()

  const disabled = useMemo(() => {
    return control?.props.disabled || false
  }, [control?.props.disabled])

  const disabledStyles = useMemo(() => {
    if (disabled) return [styles.disabledLabel, overrides?.disabledLabel]

    return []
  }, [styles.disabledLabel, overrides?.disabledLabel, disabled])

  return (
    <label
      data-testid="hero-formControlLabel"
      {...rootProps}
      className="hero-formControlLabel_root"
      css={[styles.root, overrides?.root]}
    >
      {control}
      <span
        css={[styles.labelText, overrides?.labelText, ...disabledStyles]}
        className="hero-formControlLabel_labelText"
      >
        {label}
      </span>
    </label>
  )
}
